import { useEffect, useState } from "react";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import styles from "./SimpleRecaptcha.module.scss";
import SVG from "react-inlinesvg";
import { spinnerSVG, reloadSVG } from "../../../../../shared/helpers/icons";

const COUNT_CHARACTER = 6;

const BACKGROUND_COLOR = "white";

const TEXT_COLOR = "black";

const DEFAULT_TEXT = "";

export default function SimpleCaptcha(simpleCaptchaProps) {
  const { handleCaptcha, label } = simpleCaptchaProps;

  const [captchaVerified, setCaptchaVerified] = useState(false);

  const [captchaReload, setCaptchaReload] = useState(false);

  const [inputValue, setInputValue] = useState(DEFAULT_TEXT);

  const handleValidateCaptcha = (value) => {
    const result = validateCaptcha(value, false);
    setCaptchaVerified(result);
  };

  useEffect(() => {
    loadCaptchaEnginge(COUNT_CHARACTER, BACKGROUND_COLOR, TEXT_COLOR);
  }, []);

  useEffect(() => {
    handleCaptcha(captchaVerified);
  }, [captchaVerified]);

  const handleInputChange = (event) => {
    const value = event.target.value;

    setInputValue(value);

    if (value.length === COUNT_CHARACTER) {
      handleValidateCaptcha(value);
      return;
    }

    setCaptchaVerified(false);
  };

  const handleCaptchaReload = () => {
    setCaptchaReload(true);

    setTimeout(() => {
      loadCaptchaEnginge(6);
      setCaptchaReload(false);
      setCaptchaVerified(false);
      setInputValue(DEFAULT_TEXT);
    }, 500);
  };

  return (
    <div className={styles.recaptchaWrapper}>
      <div className={styles.descriptionWrapper}>{label}</div>
      <div className={styles.captchaGeneratedWrapper}>
        <LoadCanvasTemplateNoReload />
        <button
          onClick={handleCaptchaReload}
          className={styles.buttonReload}
          disabled={captchaReload}
        >
          {captchaReload ? (
            <div className={styles.spinnerWrapper}>
              <SVG src={spinnerSVG} />
            </div>
          ) : (
            <div className={styles.reloadWrapper}>
              <SVG src={reloadSVG} />
            </div>
          )}
        </button>
      </div>
      <input
        type="text"
        className={styles.inputWrapper}
        value={inputValue}
        onChange={handleInputChange}
      />
    </div>
  );
}
